var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},_vm._l((_vm.content),function(item,item_idx){return _c(_vm.get_component(item.is),{key:'bar-item-'+item_idx,ref:'bar-item-'+item_idx,refInFor:true,tag:"component",class:item.class,attrs:{"item":item,"id":item.id,"is_open":_vm.menu_open},on:{"click":(event) => _vm.toggle_menu('bar-item-'+item_idx, event)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }